export const REPLAY_ON_CLICK_GAME = 'GENERATOR_GAME/REPLAY_ON_CLICK_GAME';

export const replayGame = () => ({
  type: REPLAY_ON_CLICK_GAME,
});
